import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '2758664024470345';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-cream text-ink selection:bg-forest/20 selection:text-forest" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <TestimonialsStrip data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SolutionReveal data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <ExtendedTestimonials data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <PurchaseNotifications data-id="element-14" />
    </div>;
}